// automatically generated by the FlatBuffers compiler, do not modify

export enum ModeStatus {
  Attendant = 0,
  Simplex = 1,
  IR = 2,
  VIP = 3,
  Security = 4,
  MOS = 5,
  InService = 6,
  Inspection = 7,
  Independent = 8
}
